import { CircularLine, CircularTerm, FinanceCircular } from '../types/catalog';

// Circular Mobilize Financial Services (Renault) — Canal convencional, disponible para PF/PJ.
// Vehículos utilitarios y particulares. Cuota con el coeficiente "Cuota inicial c/ $1.000".
// "Aporte CNC" se guarda como dato interno (no se muestra al público).

const t = (term: number, tna: number, dealerContributionPct: number, installmentPer1000: number): CircularTerm => ({
  term,
  tna,
  dealerContributionPct,
  installmentPer1000,
});

const line = (id: string, name: string, models: string[], maxAmount: number, terms: CircularTerm[]): CircularLine => ({
  id: `renault-${id}`,
  name,
  detail: `Exclusiva ${models.join(' / ')}`,
  maxAmount,
  models,
  rateType: 'fija',
  audience: 'general',
  channel: 'CONVENCIONAL',
  terms,
});

export const renaultCircular: FinanceCircular = {
  brandId: 'renault',
  lender: 'Mobilize Financial Services',
  reference: 'Circular Mobilize · Canal convencional PF/PJ · Octubre 2026',
  validFrom: '2026-10-01',
  validUntil: '2026-10-31',
  managementFeePct: null,
  notes: ['Disponible para personas físicas y jurídicas.', 'La cuota no incluye seguro automotor.', 'Sujeto a aprobación crediticia de Mobilize Financial Services.'],
  lines: [
    // ---------- Utilitarios ----------
    line('alaskan-24', 'Línea Alaskan 24', ['Alaskan'], 24000000, [t(12, 4.9, 12, 86.42), t(36, 29.9, 12, 47.63), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),
    line('alaskan-20', 'Línea Alaskan 20', ['Alaskan'], 20000000, [t(18, 9.9, 12, 61.74), t(24, 14.9, 12, 51.05)]),

    line('oroch-20-t0', 'Oroch Tasa 0%', ['Oroch'], 20000000, [t(12, 0, 9, 83.33)]),
    line('oroch-18-t0', 'Oroch Tasa 0%', ['Oroch'], 18000000, [t(18, 0, 9, 55.56)]),
    line('oroch', 'Línea Oroch', ['Oroch'], 16000000, [t(24, 9.9, 12, 47.83), t(36, 29.9, 12, 47.63), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),

    line('kvu-25-t0', 'Kangoo Express Tasa 0%', ['Kangoo Express'], 25000000, [t(12, 0, 9, 83.33)]),
    line('kvu-20-t0', 'Kangoo Express Tasa 0%', ['Kangoo Express'], 20000000, [t(18, 0, 9, 55.56)]),
    line('kvu-16-t0', 'Kangoo Express Tasa 0%', ['Kangoo Express'], 16000000, [t(24, 0, 9, 41.67)]),
    line('kvu-13-t0', 'Kangoo Express Tasa 0%', ['Kangoo Express'], 13000000, [t(30, 0, 12, 33.33)]),
    line('kvu-16', 'Línea Kangoo Express 16', ['Kangoo Express'], 16000000, [t(36, 29.9, 12, 47.63)]),
    line('kvu-19', 'Línea Kangoo Express 19', ['Kangoo Express'], 19000000, [t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),

    line('master-30-t0', 'Master Tasa 0%', ['Master'], 30000000, [t(12, 0, 9, 83.33)]),
    line('master-30', 'Línea Master 30', ['Master'], 30000000, [t(18, 11.9, 12, 63.02)]),
    line('master-40', 'Línea Master 40', ['Master'], 40000000, [t(24, 26.9, 12, 59.04), t(36, 36.9, 12, 52.78), t(48, 43.9, 12, 52.2), t(60, 49.9, 12, 54.27)]),

    // ---------- Particulares ----------
    line('boreal-30-t0', 'Boreal Tasa 0%', ['Boreal'], 30000000, [t(12, 0, 9, 83.33)]),
    line('boreal-27-t0', 'Boreal Tasa 0%', ['Boreal'], 27000000, [t(18, 0, 12, 55.56)]),
    line('boreal-25-t0', 'Boreal Tasa 0%', ['Boreal'], 25000000, [t(18, 0, 9, 55.56)]),
    line('boreal-20-t0', 'Boreal Tasa 0%', ['Boreal'], 20000000, [t(24, 0, 12, 41.67)]),
    line('boreal-19-t0', 'Boreal Tasa 0%', ['Boreal'], 19000000, [t(24, 0, 9, 41.67)]),
    line('boreal-14-t0', 'Boreal Tasa 0%', ['Boreal'], 14000000, [t(30, 0, 12, 33.33)]),
    line('boreal-18', 'Línea Boreal 18', ['Boreal'], 18000000, [t(36, 24.9, 12, 44.06), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),

    line('koleos-35', 'Línea Koleos', ['Koleos'], 35000000, [t(12, 9.9, 12, 89.6)]),
    line('koleos-30', 'Línea Koleos', ['Koleos'], 30000000, [t(18, 14.9, 12, 64.95)]),

    line('kvp-17-t0', 'Kangoo VP Tasa 0%', ['Kangoo VP'], 17000000, [t(12, 0, 9, 83.33)]),
    line('kvp-15-t0', 'Kangoo VP Tasa 0%', ['Kangoo VP'], 15000000, [t(18, 0, 9, 55.56)]),
    line('kvp-13-t0', 'Kangoo VP Tasa 0%', ['Kangoo VP'], 13000000, [t(24, 0, 9, 41.67)]),
    line('kvp-11-t0', 'Kangoo VP Tasa 0%', ['Kangoo VP'], 11000000, [t(30, 0, 12, 33.33)]),
    line('kvp', 'Línea Kangoo VP', ['Kangoo VP'], 15000000, [t(24, 9.9, 12, 47.83), t(36, 29.9, 12, 47.63), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),

    line('duster-25-t0', 'Duster Tasa 0%', ['Duster'], 25000000, [t(12, 0, 9, 83.33)]),
    line('duster-17-t0', 'Duster Tasa 0%', ['Duster'], 17000000, [t(18, 0, 9, 55.56)]),
    line('duster-14-t0', 'Duster Tasa 0%', ['Duster'], 14000000, [t(24, 0, 12, 41.67)]),
    line('duster-12-t0', 'Duster Tasa 0%', ['Duster'], 12000000, [t(24, 0, 9, 41.67)]),
    line('duster-11-t0', 'Duster Tasa 0%', ['Duster'], 11000000, [t(30, 0, 12, 33.33)]),
    line('duster-20', 'Línea Duster 20', ['Duster'], 20000000, [t(36, 29.9, 12, 47.63), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),

    line('kardian-28-t0', 'Kardian Tasa 0%', ['Kardian'], 28000000, [t(12, 0, 9, 83.33)]),
    line('kardian-24-t0', 'Kardian Tasa 0%', ['Kardian'], 24000000, [t(18, 0, 12, 55.56)]),
    line('kardian-21-t0', 'Kardian Tasa 0%', ['Kardian'], 21000000, [t(18, 0, 9, 55.56)]),
    line('kardian-20-t0', 'Kardian Tasa 0%', ['Kardian'], 20000000, [t(24, 0, 12, 41.67)]),
    line('kardian-17-t0', 'Kardian Tasa 0%', ['Kardian'], 17000000, [t(24, 0, 9, 41.67)]),
    line('kardian-15-t0', 'Kardian Tasa 0%', ['Kardian'], 15000000, [t(30, 0, 12, 33.33)]),
    line('kardian-18', 'Línea Kardian', ['Kardian'], 18000000, [t(36, 27.9, 12, 46.19), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),

    line('arkana-27-t0', 'Arkana Tasa 0%', ['Arkana'], 27000000, [t(12, 0, 9, 83.33)]),
    line('arkana-22-t0', 'Arkana Tasa 0%', ['Arkana'], 22000000, [t(18, 0, 9, 55.56)]),
    line('arkana-27', 'Línea Arkana 27', ['Arkana'], 27000000, [t(18, 9.9, 12, 61.74), t(24, 24.9, 12, 57.68)]),
    line('arkana-15-t0', 'Arkana Tasa 0%', ['Arkana'], 15000000, [t(24, 0, 9, 41.67)]),
    line('arkana-13-t0', 'Arkana Tasa 0%', ['Arkana'], 13000000, [t(30, 0, 12, 33.33)]),
    line('arkana-22', 'Línea Arkana 22', ['Arkana'], 22000000, [t(36, 29.9, 12, 47.63)]),

    line('kwid-18-t0', 'Kwid Tasa 0%', ['Kwid'], 18000000, [t(12, 0, 9, 83.33)]),
    line('kwid-16-t0', 'Kwid Tasa 0%', ['Kwid'], 16000000, [t(18, 0, 9, 55.56)]),
    line('kwid-14-t0', 'Kwid Tasa 0%', ['Kwid'], 14000000, [t(24, 0, 12, 41.67)]),
    line('kwid-12-t0', 'Kwid Tasa 0%', ['Kwid'], 12000000, [t(24, 0, 9, 41.67)]),
    line('kwid-10-t0', 'Kwid Tasa 0%', ['Kwid'], 10000000, [t(30, 0, 12, 33.33)]),
    line('kwid', 'Línea Kwid', ['Kwid'], 14000000, [t(36, 29.9, 12, 47.63), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),

    line('logan-t0', 'Logan Tasa 0%', ['Logan'], 15000000, [t(12, 0, 9, 83.33), t(18, 0, 9, 55.56)]),
    line('logan', 'Línea Logan', ['Logan'], 15000000, [t(24, 9.9, 12, 47.83), t(36, 29.9, 12, 47.63), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),

    line('sandero-t0', 'Sandero / Stepway Tasa 0%', ['Sandero'], 15000000, [t(12, 0, 9, 83.33)]),
    line('sandero', 'Línea Sandero / Stepway', ['Sandero'], 15000000, [t(18, 9.9, 12, 61.74), t(24, 14.9, 12, 51.05), t(36, 29.9, 12, 47.63), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),
    line('stepway-t0', 'Stepway Tasa 0%', ['Stepway'], 15000000, [t(12, 0, 9, 83.33)]),
    line('stepway', 'Línea Stepway', ['Stepway'], 15000000, [t(18, 9.9, 12, 61.74), t(24, 14.9, 12, 51.05), t(36, 29.9, 12, 47.63), t(48, 34.9, 12, 45.02), t(60, 34.9, 12, 41.53)]),
  ],
};
